import ReactQuill from "react-quill";
import type Parchment from "parchment";

let initialized = false;

// Use ReactQuill's Quill instance
const Quill = ReactQuill.Quill;

const Embed = Quill.import("blots/embed") as typeof Parchment.Embed;

class CustomVariableBlot extends Embed {
	static blotName = "variable";
	static tagName = "span";
	static className = "custom-variable";

	static create({ value, label }: { value: string; label: string }) {
		const node = super.create({ value, label }) as HTMLElement;
		node.setAttribute("class", this.className);
		node.setAttribute("data-name", value);
		node.setAttribute("contenteditable", "false");
		node.setAttribute("spellcheck", "false");
		
		// Create a wrapper structure to ensure proper cursor navigation
		const wrapper = document.createElement("span");
		wrapper.setAttribute("contenteditable", "false");
		wrapper.style.display = "inline-block";
		wrapper.style.whiteSpace = "nowrap";
		wrapper.textContent = label;
		
		node.appendChild(wrapper);
		
		return node;
	}

	static value(node: HTMLElement) {
		const wrapper = node.querySelector("span");
		return {
			value: node.getAttribute("data-name") || "",
			label: wrapper ? wrapper.textContent || "" : node.textContent || "",
		};
	}
}

export const setupCustomBlot = () => {
	if (initialized) return;
	Quill.register(CustomVariableBlot);
	initialized = true;
};

export default CustomVariableBlot;
